import ToEducatorDashboard from './ToEducatorDashboard';

export default ToEducatorDashboard